import React from "react";
import { ContentSection } from "sprint-common-web";

import {
    ensureSubtitleFileRecordDetails,
    FileRecordDetails
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { SubtitleFileRecordLanguagesView } from "../../../../../../common/file-record-details/languages/SubtitleFileRecordLanguagesView";

interface SubtitleFileRecordLanguagesSectionProps {
    height: number;
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const SubtitleFileRecordLanguagesSection = ({
    height,
    fileRecordDetails,
    isFileRecordDetailsLoading
}: SubtitleFileRecordLanguagesSectionProps): JSX.Element => {
    ensureSubtitleFileRecordDetails(fileRecordDetails);

    return (
        <ContentSection
            header="File record languages"
            isLoading={isFileRecordDetailsLoading}
            testId="languages-content-section"
        >
            <SubtitleFileRecordLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
        </ContentSection>
    );
};
